import React from 'react';
import { Avatar, Box, Flex, Text, useTheme } from 'native-base';
import { Platform } from 'react-native';
import RenderHtml from 'react-native-render-html';
import { DEVICE_WIDTH, AVATAR_SIZE } from '../Constants';
import { addInlineStyleToMentionBlot, displayTime, getSourceHTML } from '../utils/helpers';
import { useMessagesState } from '../../context/messages';
import { useDomParser } from '../hooks/useDomParser';
import { useEnvState } from '../../context/env';

// moved this outside of function component body to prevent it from affecting performance
const tagsStyles = {
  p: {
    margin: 0,
    padding: 0
  }
};
const PrivateMessage = ({
  pmsg
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const {
    created_at,
    name: friendlyUsername,
    username: discourseUsername,
    yours,
    avatar_template
  } = pmsg;
  let sourceHTML = getSourceHTML(pmsg, colors); // pmsg.cooked will be used
  const avatarTemplate = avatar_template.replace(/\{size\}/, AVATAR_SIZE);
  const envState = useEnvState();
  const messagesState = useMessagesState();
  const {
    getParser,
    normalizeImages,
    displayAtMentions
  } = useDomParser();

  // parse/normalize markup
  const parser = getParser();
  if (parser) {
    sourceHTML = normalizeImages(parser, sourceHTML, DEVICE_WIDTH);
    sourceHTML = displayAtMentions(parser, sourceHTML);
    sourceHTML = addInlineStyleToMentionBlot(parser, sourceHTML, colors);
  }
  const possibleNotYoursOptions = Object.keys(colors.privateMessage).filter(n => n.match(/^notYours/));
  const chosenThemeIndex = messagesState.message_users.findIndex(e => {
    return discourseUsername === e.username;
  }) % possibleNotYoursOptions.length;
  const chosenColor = possibleNotYoursOptions[Math.max(chosenThemeIndex, 0)];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    px: 4,
    bg: colors.privateMessage.box.bg,
    ml: yours ? 6 : 2,
    my: 1,
    w: yours ? '85%' : '90%'
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: yours ? 'row-reverse' : 'row',
    alignItems: 'center',
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Box, {
    h: '100%'
  }, avatarTemplate ? /*#__PURE__*/React.createElement(Avatar, {
    source: {
      uri: `${envState === null || envState === void 0 ? void 0 : envState.base_url}${avatarTemplate}`
    },
    size: 'sm',
    mt: 2
  }, "Replier Profile Image") : /*#__PURE__*/React.createElement(Text, {
    color: colors.privateMessage.user.name
  }, friendlyUsername.charAt(0).toUpperCase())), /*#__PURE__*/React.createElement(Flex, {
    direction: 'column',
    justifyContent: 'center',
    ml: 2,
    p: 3,
    width: '100%',
    borderWidth: 1,
    borderRadius: 10,
    borderColor: yours ? colors.privateMessage.yours.border : colors.privateMessage[chosenColor].border,
    bg: yours ? colors.privateMessage.yours.bg : colors.privateMessage[chosenColor].bg
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 'sm',
    fontWeight: 'bold',
    mb: 1
  }, friendlyUsername), /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.privateMessage.content
  }, /*#__PURE__*/React.createElement(RenderHtml, {
    defaultTextProps: {
      selectable: true
    },
    contentWidth: Platform.OS === 'web' ? null : DEVICE_WIDTH,
    tagsStyles: tagsStyles
    // source={{html: cooked}}
    ,
    source: {
      html: sourceHTML
    }
  })), /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.privateMessage.created
  }, displayTime(created_at), " ago")))));
};
export default PrivateMessage;
//# sourceMappingURL=PrivateMessage.js.map